"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.TitleComponent = (props) => {
    const { field } = props;
    return (React.createElement("label", { className: "small mr-2" },
        field.title.toUpperCase(),
        field.required ?
            React.createElement("span", { className: "text-danger" }, " * ") : null,
        !!field.description ? React.createElement("span", { "data-tip": field.description, style: {
                background: 'grey',
                color: 'white',
                padding: 5,
                borderRadius: 5
            } }, "?") : null));
};
//# sourceMappingURL=TitleComponent.js.map